import { createSlice } from "@reduxjs/toolkit";
import { StatusServiceModule } from "../../types/serviceModuleTypes";
import { fetchStatusServiceModuleThunk } from "../thunk/statusServiceModuleThunk";

export interface StatusServiceModuleState {
  module: StatusServiceModule | null;
}

const initialState: StatusServiceModuleState = {
  module: null,
};

export const statusServiceModuleSlice = createSlice({
  name: "statusServiceModule",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchStatusServiceModuleThunk.fulfilled, (state, action) => {
      state.module = action.payload;
    });
  },
});

export default statusServiceModuleSlice.reducer;
